import React, { useState } from "react";

function ShedRemovalFAQs() {
  const [openAccordionIndex, setOpenAccordionIndex] = useState(null);

  const toggleAccordion = (index) => {
    // Toggle the current accordion's open state
    setOpenAccordionIndex((prevIndex) => (prevIndex === index ? null : index));
  };

  const accordionItems = [
    {
      title: "How much does shed removal cost?",
      content: `
  The removal costs depend on the shed size, materials, and complexity of the job. We offer free estimates and upfront pricing with no surprises.
      `,
    },
    {
      title: "Do you offer same-day service?",
      content: `
      Yes! We provide same-day service and next-day appointments based on availability.
      `,
    },
    {
      title: "Do I need to be present during the removal?",
      content: `
       Not necessarily! We can follow your instructions even if you can’t be there in person.
      `,
    },
    {
      title: "What do you do with the removed materials?",
      content: `
         We recycle, donate, or dispose of materials responsibly to minimize environmental impact.
        `,
    },
    {
      title: "How do I book shed removal?",
      content: `
         Just call today or message us for a free quote, schedule a time, and let us handle the rest!
          `,
    },
  ];

  return (
    <div>
      <main>
        <div className="accordion">
          {accordionItems.map((item, index) => (
            <div className="accordion-item" key={index}>
              <div
                className="accordion-item-header"
                onClick={() => toggleAccordion(index)}
                style={{ cursor: "pointer" }}
              >
                <span className="accordion-item-header-title">
                  {item.title}
                </span>
                <svg
                  xmlns="http://www.w3.org/2000/svg"
                  width="16"
                  height="16"
                  fill="currentColor"
                  class="bi bi-chevron-down"
                  viewBox="0 0 16 16"
                >
                  <path
                    fill-rule="evenodd"
                    d="M1.646 4.646a.5.5 0 0 1 .708 0L8 10.293l5.646-5.647a.5.5 0 0 1 .708.708l-6 6a.5.5 0 0 1-.708 0l-6-6a.5.5 0 0 1 0-.708"
                  />
                </svg>
              </div>
              <div
                className="accordion-item-description-wrapper"
                style={{
                  display: openAccordionIndex === index ? "block" : "none",
                }}
              >
                <div className="accordion-item-description furniture-faq">
                  <hr />
                  <p>{item.content}</p>
                </div>
              </div>
            </div>
          ))}
        </div>
      </main>
    </div>
  );
}

export default ShedRemovalFAQs;
